import React, { useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import blogPosts from './blogData';
import AdComponent from './AdComponent';
import '../css/BlogPage.css';

const setMetaTag = (attr, key, value) => {
  if (!value) return;
  let tag = document.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', value);
};

const BlogPostPage = () => {
  const { slug } = useParams();
  const post = useMemo(() => blogPosts.find((item) => item.slug === slug), [slug]);
  const recent = useMemo(
    () =>
      blogPosts
        .filter((item) => item.slug !== slug)
        .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
        .slice(0, 4),
    [slug]
  );

  React.useEffect(() => {
    if (!post) return;
    const title = `${post.title} | BlinkURL Blog`;
    document.title = title;
    setMetaTag('name', 'description', post.excerpt);
    setMetaTag('property', 'og:title', title);
    setMetaTag('property', 'og:description', post.excerpt);
    setMetaTag('property', 'og:url', `${window.location.origin}/blog/${post.slug}`);
    setMetaTag('name', 'twitter:title', title);
    setMetaTag('name', 'twitter:description', post.excerpt);
  }, [post]);

  if (!post) {
    return (
      <div className="blog-shell">
        <div className="blog-empty">That update could not be found.</div>
      </div>
    );
  }

  return (
    <div className="blog-shell">
      <article className={`blog-post theme-${post.theme}`}>
        <Link to="/blog" className="blog-back">
          ← Back to Blog
        </Link>
        <div className="blog-post-header">
          <div>
            <span className="blog-kicker">{post.category}</span>
            <h1>{post.title}</h1>
            <p>{post.excerpt}</p>
          </div>
          <div className="blog-post-meta">
            <span>{new Date(post.date).toLocaleDateString()}</span>
            <span>{post.readTime}</span>
            <span>{post.author}</span>
          </div>
        </div>
        <div className="blog-tag-row">
          {post.tags.map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>

        <div className="blog-post-body">
          {post.content.map((block, index) => {
            let element = null;
            if (block.type === 'subheading') {
              element = <h2>{block.text}</h2>;
            } else if (block.type === 'list') {
              element = (
                <ul>
                  {block.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              );
            } else if (block.type === 'callout') {
              element = <div className="blog-callout">{block.text}</div>;
            } else {
              element = <p>{block.text}</p>;
            }
            return (
              <React.Fragment key={`${block.type}-${index}`}>
                {element}
                {index === 0 && (
                  <div className="taboola-mid">
                    <AdComponent containerId={`taboola-mid-article-${post.slug}`} />
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </article>

      <aside className="blog-recent">
        <h3>Recent updates</h3>
        {recent.map((item) => (
          <Link key={item.slug} to={`/blog/${item.slug}`}>
            {item.title}
          </Link>
        ))}
      </aside>
    </div>
  );
};

export default BlogPostPage;
